import { createFeatureSelector, createSelector } from '@ngrx/store';

import { GoogleServicesState } from './google-services.state';

export const getGoogleServicesState = createFeatureSelector<GoogleServicesState>('google-services');

export const getGoogleServicesGtmEnabled = createSelector(
    getGoogleServicesState,
    (state: GoogleServicesState) => state?.enabled
);
